import React, { Component } from 'react';
import SchoolSubmissionAnalyticsNavigation from "../pages/assignment-analytics/SchoolSubmissionAnalyticsNavigation";
import AcademicYearPicker from "../AcademicYearPicker";
import * as H from "history";
import AnalyticsDateControls from "../AnalyticsDateControls";
import SchoolAssignmentFetchStatus from "../pages/assignment-analytics/SchoolAssignmentFetchStatus";

interface AnalyticsControlBarProps {
    tenantId: string;
    schoolCode: string;
    
    startDate?: string,
    endDate?: string,
    academicYear: number,
    
    current: "overview" | "student" | "teacher" | "yearGroup" | "subject";
    
    onAcademicYearChanged: (academicYear: number) => void;
    
    history: H.History;
}

interface AnalyticsControlBarState {
}

export default class AnalyticsControlBar extends Component<AnalyticsControlBarProps, AnalyticsControlBarState> {
    static displayName = AnalyticsControlBar.name;

    constructor(props: AnalyticsControlBarProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount(): void {
    }

    componentDidUpdate(prevProps: Readonly<AnalyticsControlBarProps>, prevState: Readonly<AnalyticsControlBarState>, snapshot?: any): void {
    }

    render(): JSX.Element {
        return (
            <div className={"analytics-control-bar"}>
                <SchoolSubmissionAnalyticsNavigation tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} current={this.props.current} academicYear={this.props.academicYear} startDate={this.props.startDate} endDate={this.props.endDate} />
                <div className={"analytics-control-bar__filter-area"}>
                    <div className={"analytics-control-bar__filter-controls"}>
                        <AcademicYearPicker history={this.props.history} onSelectedKeyChange={this.props.onAcademicYearChanged} />
                        <AnalyticsDateControls classNameOverride={""} history={this.props.history} />
                    </div>
                    <SchoolAssignmentFetchStatus tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} academicYear={this.props.academicYear} />
                </div>
            </div>
        );
    }
}